import * as React from 'react'

/**
 * @description QAtester icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { QAtester } from '@sravni/design-system-icons'
 *
 * <QAtester />
 * ```
 */
export const QAtester = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="QAtester" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.197 9.167H4.07c-.92 0-1.667-.746-1.667-1.667V3.333c0-.92.746-1.666 1.667-1.666h13.333c.921 0 1.667.746 1.667 1.666V7.5c0 .92-.746 1.667-1.667 1.667H8.697"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.698 10.833v-3.75a1.25 1.25 0 0 0-2.5 0v6.25l-.75-.75a1.295 1.295 0 0 0-1.994 1.634l2.25 3.374c.308.464.83.742 1.387.742h4.406c.841 0 1.55-.625 1.655-1.46l.451-3.614c.111-.889-.5-1.707-1.385-1.851l-3.52-.575ZM15.522 5.416a.203.203 0 1 0-.407.001.203.203 0 0 0 .407-.001M12.19 5.416a.203.203 0 1 0-.407.001.203.203 0 0 0 .407-.001"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
